module.exports = __webpack_public_path__ + "img/icon-indices.f7e04b87.svg";